<template>
  <div class="flex flex-col gap-6 p-4">
    <NuxtLink
      v-if="isAuthenticated"
      role="button"
      @click="handleAccountClick"
    >
      <KikIcon
        icon="profile_filled"
        size="base"
        class="mb-1 mr-1 fill-secondary"
      />
      {{ $t("Profile") }}
    </NuxtLink>
    <NuxtLink
      tabindex="0"
      role="button"
      @click="handleWishlistClick"
    >
      <SfIconFavorite
        size="base"
        class="mb-1 mr-1 fill-secondary"
      />
      {{ $t("Wishlist") }}
    </NuxtLink>
    <NuxtLink
      tabindex="0"
      role="button"
      @click="handleCartClick"
    >
      <SfIconShoppingCart
        icon="add_to_cart"
        size="base"
        class="mr-1 fill-secondary"
      />
      {{ $t("Cart") }}
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
import { SfIconFavorite, SfIconShoppingCart } from '@storefront-ui/vue';
import { useLastVisitedPage } from '~/composables/custom/useLastVisitedPage';
import { useUser } from '~/composables/custom/useUser/useUser';

const route = useRoute();
const { addPage } = useLastVisitedPage();

const { isAuthenticated } = useUser();

const emit = defineEmits(['close']);

const handleAccountClick = () => {
  emit('close');
  return navigateTo('/my-account/');
};

const handleWishlistClick = () => {
  emit('close');
  return navigateTo('/wishlist');
};

const handleCartClick = () => {
  emit('close');
  addPage(route.fullPath);
  navigateTo('/cart');
};
</script>
